import React from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer } from './primitives';

/**
 * Provenance / source metadata drawer — wraps design-system Drawer for DataPoint flows.
 * Product copy: Período / Publicado / Revisión (never “vintage”).
 */
export function ProvenanceDrawer({
  open,
  onClose,
  title,
  source,
  vintage,
  observationPeriod,
  publishedAt,
  revisionId,
  notes,
  children,
}) {
  const { t } = useTranslation();
  const periodLine = observationPeriod || vintage;
  const revisionLine = revisionId || (vintage && vintage !== observationPeriod ? vintage : null);
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={title || t('designSystem.provenanceTitle')}
      side="right"
    >
      {source ? (
        <p className="ds-provenance__row">
          <strong>{t('designSystem.provenanceSource')}:</strong> {source}
        </p>
      ) : null}
      {periodLine ? (
        <p className="ds-provenance__row">
          <strong>{t('designSystem.provenancePeriod')}:</strong> {periodLine}
        </p>
      ) : null}
      {publishedAt ? (
        <p className="ds-provenance__row">
          <strong>{t('designSystem.provenancePublished')}:</strong> {publishedAt}
        </p>
      ) : null}
      {revisionLine ? (
        <p className="ds-provenance__row">
          <strong>{t('designSystem.provenanceRevision')}:</strong> {revisionLine}
        </p>
      ) : null}
      {notes ? <p className="ds-provenance__notes">{notes}</p> : null}
      {children}
    </Drawer>
  );
}

export default ProvenanceDrawer;
